import { render, staticRenderFns } from "./EstablishmentStateComments.vue?vue&type=template&id=ca72b852&"
import script from "./EstablishmentStateComments.vue?vue&type=script&lang=js&"
export * from "./EstablishmentStateComments.vue?vue&type=script&lang=js&"
import style0 from "./EstablishmentStateComments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EstablishmentStateComments.vue"
export default component.exports